module.exports = __webpack_public_path__ + "static/media/18c-03_barro.5d5c3f21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18c/18c-03_barro.jpg
// module id = 230
// module chunks = 0